import PINInput from './PIN';

export default PINInput;
